@if (isAllowToShowTerm) {
  <main class="legal-page"
    role="main"
    [attr.aria-label]="'ACCESSIBILITY.DATA_PROCESS_TERMS' | translate">
    <div class="legal-page-column">
      <h1 id="data-process-terms-title" class="legal-page-title">{{ 'LEGAL.TITLE.DATA-PROCESS-TERMS' | translate }}</h1>
      <article class="legal-card" role="article" aria-labelledby="data-process-terms-title">
        <section class="terms-content"
          role="region"
          [attr.aria-label]="'ACCESSIBILITY.LEGAL_CONTENT' | translate"
          [innerHTML]="'LEGAL.DATA-PROCESS-TERMS.BODY' | translate: {dataSecurityLink: dataSecurityLink}">
        </section>
        <footer class="consent-actions" role="contentinfo">
          <div class="link-wrapper"
            role="group"
            [attr.aria-label]="'ACCESSIBILITY.TERMS_DECISION_BUTTONS' | translate">
            <button id="logout"
              type="button"
              class="btn consent-decline"
              (click)="logout()"
              [attr.aria-label]="'ACCESSIBILITY.DECLINE_TERMS' | translate">
              {{'LEGAL.BUTTON.NO' | translate}}
            </button>
            <button id="accept_button"
              type="button"
              class="button dark-blue consent-accept"
              (click)="acceptDataProcess()"
              [attr.aria-label]="'ACCESSIBILITY.ACCEPT_TERMS' | translate">
              {{ 'LEGAL.BUTTON.I-ACCEPT' | translate }}
            </button>
          </div>
        </footer>
      </article>
    </div>
  </main>
}
@if (!isAllowToShowTerm) {
  <main class="legal-page"
    role="main"
    [attr.aria-label]="'ACCESSIBILITY.DATA_PROCESS_TERMS_READONLY' | translate">
    <div class="legal-page-column">
      <h1 id="data-process-terms-title" class="legal-page-title">{{ 'LEGAL.TITLE.DATA-PROCESS-TERMS' | translate }}</h1>
      <article class="legal-card"
        role="article"
        aria-labelledby="data-process-terms-title"
        [innerHTML]="'LEGAL.DATA-PROCESS-TERMS.BODY' | translate: {dataSecurityLink: dataSecurityLink}">
      </article>
    </div>
  </main>
}
